import {BaseMobxStore} from "../../infrastructure/mobx/base-mobx-store";
import {OddsByWidgetConfig} from "./odds-by-widget.config";
import {OddsByWidgetState} from "./models/odds-by-widget.state";


export class OddsByWidgetStore extends BaseMobxStore {
  static injectables = [OddsByWidgetConfig, OddsByWidgetState];
}

